module.exports = __webpack_public_path__ + "img/result-y7.5362fec0.png";